module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_inomemado@2x-f642e8ccc18ce99cf8d361feef4ba72a.webp";